export interface StatusDTO {
  id: number;
  statusName: string;
  updated: string;
  added: string;
}
